import { makeStyles } from "@mui/styles";

export const FiltrosStyles = makeStyles(() => ({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0.5em",
    },
    filtros: {
        display: "flex",
        alignItems: "center",
        flexGrow: 1,
    },
    inputContainer: {
        position: "relative",
    },
    input: {
        flexDirection: "row",
        marginRight: "1rem",

        "& .MuiInputBase-root": {
            width: "var(--filter-input-width, 150px)",
        },
        "& .MuiInputBase-input": {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
        },
    },
    iconoBorrar: {
        height: "12px",
        width: "12px",
        position: "absolute",
        right: "2rem",
        bottom: "16px",
        cursor: "pointer",
    },
    total: {
        margin: 0,
        height: "4rem",
        display: "flex",
        alignItems: "center",
        flexGrow: 1,
        paddingBottom: "6px",
        boxSizing: "border-box",
    },
    marginNormal: {
        marginBottom: "8px",
        marginTop: "16px",
        display: "flex",
        alignItems: "flex-end",
    },
    button: {
        width: "fit-content",
    },
}));
